import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, CircularProgress, Divider, Grid, LinearProgress } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import { FHEButton, OneWifiProduct, FHEWifiForm } from 'data/components';
import { Logger, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { getAPWifiProductsList, connectToAP, getWifiList, startProductInclusion } from '../../../../data/Products/actions';

class WizardAddProduct extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        homeBoxMac: PropTypes.string.isRequired,
        middlewareState: PropTypes.string.isRequired,
        getAPWifiProductsList: PropTypes.func.isRequired,
        connectToAP: PropTypes.func.isRequired,
        getWifiList: PropTypes.func.isRequired,
        startProductInclusion: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.mounted = true;
        this.state = {
            step: 'loadingMiddleware',

            /* LISTS */
            apList: [],
            selectedProductIdentifier: '',
            selectedProductType: '',
            selectedProductSsid: '',
            apSelected: {},
            wifiList: [],
            wifiForm: {
                ssid: null,
                password: null,
                encryption: 'WPA2',
                encryption_type: 'TKIP'
            },

            /* HELPERS */
            showPassword: false,
            currentStepSlug: null,
            inclusionPrct: null,

            /* LOADERS */
            loading: true,
            loadingInclusion: false,

            /* ERRORS */
            error: null,
            inclusionError: null
        };
        this.delayToCheckMiddleWare = 500;
        this.maxCheckMiddleware = 10;
        this.delayToRefreshAP = 5000;
        this.setTimeoutrefreshAPWifiProductList;
    }

    componentDidMount() {
        const { middlewareState } = this.props;

        if (middlewareState !== 'connected') {
            this.checkMiddlewareState();
        } else {
            this.getAPWifiProductsList();
        }
    }
    componentWillUnmount() {
        this.mounted = false;
        clearTimeout(this.setTimeoutrefreshAPWifiProductList);
    }

    handleChange = (event, a, b) => {
        const { wifiForm } = this.state;
        let targetValue = event.target.value;

        if (targetValue === '') targetValue = null;

        this.setState({
            wifiForm: { ...wifiForm, [event.target.name]: targetValue }
        });
    };
    handleClickShowPassword = () => {
        const { showPassword } = this.state;
        this.setState({
            showPassword: !showPassword
        });
    };

    stepAction = args => {
        this.setState({
            currentStepSlug: args.step,
            inclusionPrct: Math.round((args.step_num / args.step_total) * 100)
        });
    };

    /* EVENTS */
    checkMiddlewareState = () => {
        const { history } = this.props;
        this.setState({
            step: 'loadingMiddleware',
            loading: true,
            error: null
        });
        let checkMiddleWareCount = 0;
        let checkMiddleware = setInterval(() => {
            const { middlewareState } = this.props;
            checkMiddleWareCount += 1;
            if (middlewareState === 'connected') {
                clearInterval(checkMiddleware);
                this.getAPWifiProductsList();
            }
            if (checkMiddleWareCount > this.maxCheckMiddleware) {
                this.setState({
                    error: Translator.translate(`generic.products.addProduct.error.middlewareConnectionFail`)
                });
                clearInterval(checkMiddleware);
            }
        }, this.delayToCheckMiddleWare);
    };
    getAPWifiProductsList = () => {
        const { getAPWifiProductsList, homeBoxMac } = this.props;
        this.setState({
            step: 'getAPList',
            loading: true,
            error: null
        });

        return getAPWifiProductsList(homeBoxMac)
            .then(data => {
                this.setState({
                    apList: data.ap_list,
                    wifiList: data.wifi_list,
                    step: 'listingProducts'
                });
            })
            .catch(error => {
                clearTimeout(this.setTimeoutrefreshAPWifiProductList);
                let errorString = Translator.translateWithFallback(
                    `socket.error.${error.message ? error.message : error}`,
                    `socket.error.middlewareConnectionFail`
                );
                this.setState({
                    error: errorString
                });
            })
            .finally(() => {
                this.setState({
                    loading: false
                });
                this.refreshAPWifiProductList();
            });
    };
    refreshAPWifiProductList = () => {
        if (!this.mounted) {
            return false;
        }
        const { getAPWifiProductsList, homeBoxMac } = this.props;
        const { selectedProductIdentifier } = this.state;

        return getAPWifiProductsList(homeBoxMac)
            .then(data => {
                if (this.mounted && data.ap_list) {
                    this.setState({
                        apList: data.ap_list,
                        wifiList: data.wifi_list,
                        error: null
                    });
                }
            })
            .catch(error => {
                if (!this.mounted) {
                    return false;
                }
                let errorString = Translator.translateWithFallback(
                    `socket.error.${error.message ? error.message : error}`,
                    `socket.error.middlewareConnectionFail`
                );
                this.setState({
                    error: errorString
                });
            })
            .finally(() => {
                if (this.mounted && selectedProductIdentifier === '') {
                    this.setTimeoutrefreshAPWifiProductList = setTimeout(this.refreshAPWifiProductList.bind(this), this.delayToRefreshAP);
                }
            });
    };
    getWifiList = () => {
        const { getWifiList, homeBoxMac } = this.props;

        return getWifiList(homeBoxMac).then(data => {
            if (data.success === true) {
                this.setState({
                    wifiList: data.wifi_list
                });
            }
            return data;
        });
    };
    inclusionStart = () => {
        const { wifiForm, selectedProductIdentifier, currentStepSlug } = this.state;
        const { homeBoxMac, startProductInclusion } = this.props;

        this.setState({
            loadingInclusion: true,
            inclusionError: null,
            currentStepSlug: null
        });

        return startProductInclusion(
            homeBoxMac,
            selectedProductIdentifier,
            wifiForm.ssid,
            wifiForm.password,
            wifiForm.encryption,
            wifiForm.encryption_type,
            this.stepAction
        )
            .then(data => {
                if (data.success === true) {
                    this.setState({
                        step: 'inclusionSuccess'
                    });
                }
            })
            .catch(error => {
                let errorString = Translator.translateWithFallback(
                    `socket.error.${error.message ? error.message : error}`,
                    `socket.error.${!currentStepSlug ? 'defaultError' : currentStepSlug}`
                );
                this.setState({
                    inclusionError: errorString
                });
            })
            .finally(() => {
                this.setState({
                    loadingInclusion: false
                });
            });
    };

    /* ACTIONS */
    selectProduct = (productIdentifier, productType, productSsid) => {
        const { homeBoxMac, connectToAP, history } = this.props;

        clearTimeout(this.setTimeoutrefreshAPWifiProductList);

        this.setState({
            step: 'connectProduct',
            loading: true,
            selectedProductIdentifier: productIdentifier,
            selectedProductType: productType,
            selectedProductSsid: productSsid,
            error: null
        });

        let productLabel = Translator.translateWithFallback(
            `generic.products.addProduct.widgetsList.${productType}`,
            `generic.products.addProduct.error.unknownProduct`
        );

        return connectToAP(homeBoxMac, productIdentifier)
            .then(data => {
                if (data.success === true) {
                    this.setState({
                        apSelected: {
                            productIdentifier: data.product_identifier,
                            fheCenterMac: data.fheCenter_mac,
                            productType: productType,
                            productLabel: productLabel,
                            productSsid: productSsid
                        },
                        step: 'wifiForm'
                    });
                }
            })
            .catch(error => {
                let errorString = Translator.translateWithFallback(
                    `socket.error.${error.message ? error.message : error}`,
                    `socket.error.apConnectionFail`
                );
                this.setState({
                    error: errorString
                });
            })
            .finally(() => {
                this.setState({
                    loading: false
                });
            });
    };
    selectWifi = wifi => {
        this.setState({
            wifiForm: wifi
        });
    };
    addAnotherProduct = () => {
        this.setState({
            loading: true,
            error: null,
            apList: [],
            selectedProductIdentifier: '',
            selectedProductType: '',
            selectedProductSsid: '',
            apSelected: {},
            wifiList: [],
            showPassword: false,
            currentStepSlug: null,
            inclusionPrct: null,
            inclusionError: null
        });
        this.getAPWifiProductsList();
    };
    back = () => {
        const { history } = this.props;
        Logger.verbose('Redirect to Home');
        return history.goBack();
    };

    /* RENDERS */
    renderListingProduct = () => {
        const { apList, error } = this.state;
        const { classes, theme, history } = this.props;

        let productsList = [];
        if (apList.length > 0) {
            apList.map((product, key) => {
                productsList.push(
                    <div key={key} onClick={() => this.selectProduct(product.bssid, product.product_type, product.ssid)} role="presentation">
                        <OneWifiProduct product={product} />
                        <Divider />
                    </div>
                );
            });
        } else {
            productsList.push(
                <div key="0" className={classes.errorTextContainer}>
                    <div style={{ color: theme.palette.error.main }}>
                        {error ? error : Translator.translate(`generic.products.addProduct.error.noProductsFound`)}
                    </div>
                </div>
            );
        }
        return (
            <div>
                <div className={classes.title}>{Translator.translate(`generic.products.addProduct.productList`)}</div>
                <div className={classes.errorTextContainer}>{error ? <div style={{ color: theme.palette.error.main }}>{error}</div> : null}</div>
                <div className="d-flex align-content-center align-items-center">
                    <div className={apList.length > 0 ? classes.productListContainer : classes.productListContainerRefresh}>{productsList}</div>
                </div>
                <div className={classes.infoUpdate}>
                    <Refresh className={classes.smallIcon} />
                    <span>{Translator.translate(`generic.products.addProduct.infoUpdateProductList`)}</span>
                </div>

                <Grid container justify="center" alignItems="center" spacing={3} className={classes.wifiFormContainer}>
                    <Grid container item sm={12} md={6} xl={3} justify="center" alignItems="center">
                        <FHEButton content={Translator.translate(`generic.products.addProduct.close`)} clickFunction={this.back} />
                    </Grid>
                </Grid>
            </div>
        );
    };
    renderWifiForm = () => {
        const { theme, classes, history } = this.props;
        const { wifiForm, currentStepSlug, inclusionPrct, inclusionError, loadingInclusion, wifiList, apSelected } = this.state;
        return (
            <div>
                <div className={classes.title}>
                    {Translator.translate(`generic.products.addProduct.configWifi`, apSelected.productLabel, apSelected.productSsid)}
                </div>
                <FHEWifiForm
                    selectWifi={this.selectWifi}
                    getWifiList={this.getWifiList}
                    wifiList={wifiList}
                    ssid={wifiForm.ssid}
                    password={wifiForm.password}
                    encryption={wifiForm.encryption}
                    encryption_type={wifiForm.encryption_type}
                    handleChange={this.handleChange}
                />

                <Grid container justify="center" alignItems="center" spacing={3} className={classes.wifiFormContainer}>
                    <Grid container item sm={12} md={6} xl={3} justify="center" alignItems="center">
                        {inclusionError && <span style={{ color: theme.palette.error.main }}>{inclusionError}</span>}
                        {loadingInclusion && currentStepSlug !== null && (
                            <div className={classes.progressContainer}>
                                <LinearProgress variant="determinate" value={inclusionPrct} />
                                <div className={classes.stepContainer}>
                                    {Translator.translate(`generic.products.addProduct.steps.${currentStepSlug}`)}
                                </div>
                            </div>
                        )}
                    </Grid>
                </Grid>
                <Grid container justify="center" alignItems="center" spacing={3} className={classes.wifiFormContainer}>
                    <Grid container item sm={12} md={6} xl={3} justify="center" alignItems="center">
                        <FHEButton
                            disabled={loadingInclusion || wifiForm.ssid === null}
                            content={Translator.translate(`generic.products.addProduct.inclusionStart`)}
                            clickFunction={loadingInclusion ? () => {} : () => this.inclusionStart()}
                            loading={loadingInclusion}
                        />
                        <FHEButton
                            disabled={loadingInclusion}
                            content={Translator.translate(`generic.products.addProduct.backToProductList`)}
                            clickFunction={() => {
                                this.setState({
                                    selectedProductIdentifier: '',
                                    selectedProductType: '',
                                    selectedProductSsid: '',
                                    apSelected: {},
                                    inclusionError: null,
                                    loadingInclusion: false,
                                    currentStepSlug: null
                                });
                                this.getAPWifiProductsList();
                            }}
                        />
                        <FHEButton
                            disabled={loadingInclusion}
                            content={Translator.translate(`generic.products.addProduct.close`)}
                            clickFunction={this.back}
                        />
                    </Grid>
                </Grid>
            </div>
        );
    };

    renderSuccessView = () => {
        const { apSelected } = this.state;
        const { classes, history } = this.props;
        return (
            <Grid container justify="center" alignItems="center" spacing={3} className={classes.wifiFormContainer}>
                <Grid container item xs={12} justify="center" alignItems="center">
                    <div className={classes.confirmationText}>
                        {Translator.translate(`generic.products.addProduct.inclusionSuccess`, apSelected.productLabel, apSelected.productSsid)}
                    </div>
                </Grid>
                <Grid container item sm={12} md={6} xl={3} justify="center" alignItems="center">
                    <FHEButton
                        content={Translator.translate(`generic.products.addProduct.addAnotherProduct`)}
                        clickFunction={this.addAnotherProduct}
                    />
                    <FHEButton content={Translator.translate(`generic.products.addProduct.close`)} clickFunction={this.back} />
                </Grid>
            </Grid>
        );
    };
    renderLoader = () => {
        const { classes, history } = this.props;
        const { step, selectedProductIdentifier } = this.state;
        let loadingMessage = '';
        if (step === 'loadingMiddleware') {
            loadingMessage = Translator.translate(`generic.products.addProduct.loadingMiddleware`);
        } else if (step === 'getAPList') {
            loadingMessage = Translator.translate(`generic.products.addProduct.loadingAPList`);
        } else if (step === 'connectProduct') {
            loadingMessage = Translator.translate(
                `generic.products.addProduct.loadingConnectAp`,
                selectedProductIdentifier
                    .toUpperCase()
                    .match(/.{1,2}/g)
                    .join(':')
            );
        }
        return (
            <div>
                <div className={classes.loadingTextContainer}>{loadingMessage}</div>
                <div className={classes.loadingContainer}>
                    <CircularProgress />
                </div>
            </div>
        );
    };
    renderError = () => {
        const { classes, theme, history } = this.props;
        const { error, step, selectedProductIdentifier, selectedProductType, selectedProductSsid } = this.state;
        let errorNotDefined = false;
        if (step !== 'connectProduct' && step !== 'loadingMiddleware' && step !== 'getAPList' && step !== 'listingProducts') {
            errorNotDefined = true;
        }
        return (
            <div className={classes.retryContainer}>
                <div className={classes.errorTextContainer}>
                    <div style={{ color: theme.palette.error.main }}>{error}</div>
                </div>
                {step === 'connectProduct' ? (
                    <div>
                        <div style={{ textAlign: 'center' }}>
                            <FHEButton
                                className={classes.button}
                                content={Translator.translate(`generic.products.addProduct.retry`)}
                                clickFunction={() => this.selectProduct(selectedProductIdentifier, selectedProductType, selectedProductSsid)}
                            />
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <FHEButton
                                className={classes.button}
                                content={Translator.translate(`generic.products.addProduct.backToProductList`)}
                                clickFunction={() => {
                                    this.setState({
                                        error: null
                                    });
                                    this.getAPWifiProductsList();
                                }}
                            />
                        </div>
                    </div>
                ) : null}
                {step === 'loadingMiddleware' || step === 'getAPList' || step === 'listingProducts' ? (
                    <div>
                        <div style={{ textAlign: 'center' }}>
                            <FHEButton
                                className={classes.button}
                                content={Translator.translate(`generic.products.addProduct.retry`)}
                                clickFunction={this.checkMiddlewareState}
                            />
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <FHEButton
                                className={classes.button}
                                content={Translator.translate(`generic.products.addProduct.close`)}
                                clickFunction={this.back}
                            />
                        </div>
                    </div>
                ) : null}
                {errorNotDefined ? (
                    <div style={{ textAlign: 'center' }}>
                        <FHEButton
                            className={classes.button}
                            content={Translator.translate(`generic.products.addProduct.close`)}
                            clickFunction={this.back}
                        />
                    </div>
                ) : null}
            </div>
        );
    };

    render() {
        const { loading, step, error } = this.state;

        if (error) return this.renderError();
        if (loading) return this.renderLoader();

        return (
            <Fragment>
                {step === 'listingProducts' ? this.renderListingProduct() : null}
                {step === 'wifiForm' ? this.renderWifiForm() : null}
                {step === 'inclusionSuccess' ? this.renderSuccessView() : null}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const middlewareState = state.environments[history.environment].middleware.getIn(['general', 'state'], 'pending');
    return {
        profile: state.data.user,
        middlewareState
    };
}

const styles = () => ({
    retryContainer: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'center'
    },
    errorTextContainer: {
        width: '100%',
        textAlign: 'center',
        marginBottom: '10px',
        marginTop: '10px'
    },
    loadingTextContainer: {
        width: '100%',
        textAlign: 'center',
        marginBottom: '20px'
    },
    productListContainer: {
        alignSelf: 'center',
        marginBottom: 20,
        marginTop: 20,
        margin: '0 auto',
        width: 'auto',
        boxShadow: `3px 3px 20px 0px rgba(0,0,0,0.25)`
    },
    productListContainerRefresh: {
        alignSelf: 'center',
        marginBottom: 20,
        marginTop: 20,
        margin: '0 auto',
        width: 'auto'
    },
    wifiFormContainer: {
        alignSelf: 'center',
        marginBottom: 5,
        marginTop: 20,
        margin: '0 auto',
        width: 'auto',
        padding: 20
    },
    stepContainer: {
        textAlign: 'center',
        marginTop: 10,
        marginBottom: 10
    },
    confirmationText: {
        marginBottom: 25
    },
    progressContainer: {
        width: '100%'
    },
    title: {
        marginBottom: 15,
        margin: '0 auto',
        textAlign: 'center',
        fontSize: '1.2em'
    },
    button: {
        marginBottom: 15,
        marginTop: 15,
        margin: '0 auto',
        textAlign: 'center',
        width: 'auto'
    },
    infoUpdate: {
        marginTop: 15,
        textAlign: 'center',
        fontSize: '0.8em',
        width: 'auto'
    },
    smallIcon: {
        fontSize: 15,
        marginRight: 8
    },
    loadingContainer: {
        margin: '0 auto',
        textAlign: 'center',
        alignSelf: 'center'
    }
});

export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/provisionning/WizardAddProduct',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        getAPWifiProductsList,
                        connectToAP,
                        getWifiList,
                        startProductInclusion
                    }),
                    dispatch
                )
        )(withStyles(styles, { withTheme: true })(WizardAddProduct))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/provisionning/WizardAddProduct.js